export enum FeatureLayerType {
  STRATEGY = 'STRATEGY',
  OBSTRUCTION = 'OBSTRUCTION',
  MUNICH_CONSTRUCTIONS = 'MUNICH_CONSTRUCTIONS',
  TRAFFIC_LIGHT = 'TRAFFIC_LIGHT',
}
